import React, { Component } from "react";
import { connect } from "react-redux";

import { 
    deactivateFaculty, activateFaculty, createFaculty, updateFaculty, getFaculties 
} from "../../../../actions/FacultyActions";

import { 
    getRoles
} from "../../../../actions/RolActions";

import { 
    DEACTIVATE_FACULTY, ACTIVATE_FACULTY, CREATE_FACULTY, UPDATE_FACULTY, GET_ERRORS, GET_FACULTIES  
} from "../../../../actions/types";
import FacultyModalComponent from "./FacultyModalComponent";

import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import BootstrapTable from "react-bootstrap-table-next";
import LoadingOverlay from "react-loading-overlay";
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";
import MuiAlert from "@material-ui/lab/Alert";
import Dialog from "@material-ui/core/Dialog";
import Icon from "@material-ui/core/Icon";

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class FacultyComponent extends Component {
    state = {
        faculties:            [],
        modalFacultyData:     null,
        textSnackBar:         "",
        modalType:            "CREATE",
		severitySnackBar:     "success",
        showDeactivateDialog: false,
        modalIsVisible:       false,
        showSnackBar:         false,
        activeLoader:         true,
        isActiveFaculty:      true,
        selectedId:           0,
    }

    constructor(props) {
        super(props);
        this.handleCloseDeactivateDialog = this.handleCloseDeactivateDialog.bind(this);
        this.onPressDeactivate           = this.onPressDeactivate.bind(this);
		this.deactivateFaculty           = this.deactivateFaculty.bind(this);
        this.onPressActivate             = this.onPressActivate.bind(this);
        this.activateFaculty             = this.activateFaculty.bind(this);
        this.onPressCancel               = this.onPressCancel.bind(this);
		this.createFaculty               = this.createFaculty.bind(this);
        this.updateFaculty               = this.updateFaculty.bind(this);
        this.onCloseModal                = this.onCloseModal.bind(this);
        this.handleClose                 = this.handleClose.bind(this);
        this.openModal                   = this.openModal.bind(this);
	}

	componentDidMount() {
		this.props.getFaculties();
		this.props.getRoles();
	}

    componentDidUpdate(prevProps) {
		if (this.state.faculties !== this.props.faculties) {
			this.setState({
				faculties: this.props.faculties,
				activeLoader: false
			})
		}
        else if (this.props.actionType === CREATE_FACULTY && prevProps.actionType !== CREATE_FACULTY) {
			this.props.getFaculties();
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Permiso creado exitosamente.",
				severitySnackBar: 'success',
			});
		}
        else if (this.props.actionType === UPDATE_FACULTY && prevProps.actionType !== UPDATE_FACULTY) {
			this.props.getFaculties();
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Permiso actualizado exitosamente.",
				severitySnackBar: 'success',
			});
		}
        else if (this.props.actionType === ACTIVATE_FACULTY && prevProps.actionType !== ACTIVATE_FACULTY) {
			this.props.getFaculties();
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Permiso activado exitosamente.",
				severitySnackBar: 'success',
			});
		}
        else if (this.props.actionType === DEACTIVATE_FACULTY && prevProps.actionType !== DEACTIVATE_FACULTY) {
			this.props.getFaculties();
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Permiso desactivado exitosamente.",
				severitySnackBar: 'success',
			});
		}
		else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				showSnackBar: true,
				textSnackBar: this.props.error,
				severitySnackBar: 'error',
			});
		}
    }

    ///---------------------------------------EVENTS-------------------------------------

    openModal = () => {
		this.setState({
			modalIsVisible: true,
			modalType: "CREATE",
		});
	};

    handleCloseDeactivateDialog = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}
		this.setState({
			showDeactivateDialog: false,
		});
	};

    createFaculty(faculty) {
		this.props.createFaculty(faculty);
		this.setState({
            activeLoader: true,
			modalIsVisible: false,
		})
	}

    updateFaculty(faculty) {
		this.props.updateFaculty(faculty);
		this.setState({
            activeLoader: true,
			modalIsVisible: false,
		})
    }
    
    activateFaculty() {
        this.setState({
            showDeactivateDialog: false,
            modalIsVisible: false,
            selectedId: 0
        })
    }

    deactivateFaculty() {
        this.props.deactivateFaculty(this.state.selectedId);
        this.setState({
            showDeactivateDialog: false,
            modalIsVisible: false,
            selectedId: 0
        })
    }

    onPressDeactivate(id) {
        this.setState({
            showDeactivateDialog: true,
            modalIsVisible: false,
            selectedId: id,
            isActiveFaculty: true
        });
	}

    onPressActivate(id) {
		this.props.activateFaculty(id);
		this.setState({
            activeLoader: true,
			modalIsVisible: false,
		})
	}

    onPressCancel() {
		this.setState({
			modalIsVisible: false,
			modalFacultyData: null
		})
		this.render();
	}

    onCloseModal() {
		this.setState({
			activeLoader: true,
			modalIsVisible: false,
			modalFacultyData: null
		})
		this.render();
	}

    handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		this.setState({
			showSnackBar: false,
		});
	};
    
    render() {
		const rowEvents = {
			onClick: (e, row, rowIndex) => {
				this.setState({
					modalType: "UPDATE",
					modalFacultyData: row,
					modalIsVisible: true,
				});
			},
		};
	  const columns = [
		{
			dataField: 'name',
			text: 'Nombre',
		},

		{
			dataField: 'description',
			text: 'Descripción',
			headerStyle: () => {
				return { width: "30%" };
			}
		},

		{
			dataField: 'key',
			text: 'Clave',
			headerStyle: () => {
				return { width: "30%" };
			}
		},
		{
			dataField: 'created_at',
			text: 'Fecha de creación',
			formatter: (cell) => cell ? new Date(cell).toLocaleDateString() : ""
		},
		{
			dataField: 'is_active',
			text: 'Estatus',
			formatter: (cell) => (cell ? "Activo" : "Inactivo"),
		},
		];

	return ( 
		<center>
			<div className="toolbar end">
				<Button
					style={{
						height: "10%",
						backgroundColor: "#2ecc71",
						padding: "0.8rem 0.8rem",
						fontSize: "0.7rem",
					}}
					variant="contained"
					color="primary"
					startIcon={<Icon>add</Icon>}
					onClick={this.openModal}
				>
					Agregar
				</Button>
			</div>
			<div
				style={{
					textAlign: "left",
					height: "1vh",
					overflow: "auto",
					width: "100%",
					marginTop: "2vh",
				}}
			>
			</div>
			{this.state.faculties && this.state.faculties.length > 0 &&
				<BootstrapTable
					keyField="_id"
					key="8908290138209"
					striped
					hover
					condensed
					rowEvents={rowEvents}
					data={this.state.faculties}
					headerWrapperClasses="title-table"
					rowClasses="custom-row-table"
					columns={columns}
				/>
			}

			{
				this.state.faculties &&
				<FacultyModalComponent
					roles = {this.props.roles}
					isVisible     = {this.state.modalIsVisible}
					modalFacultyData  = {this.state.modalFacultyData}
					deactivateFaculty = {this.onPressDeactivate}
					type          = {this.state.modalType}
					activateFaculty   = {this.onPressActivate}
					onPressCancel = {this.onPressCancel}
					onCloseModal  = {this.onCloseModal}
					createFaculty     = {this.createFaculty}
					updateFaculty     = {this.updateFaculty}
				/>
			}
			
			{
				<Dialog
					open={this.state.showDeactivateDialog}
					onClose={this.handleCloseDeactivateDialog}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">
						{"Desactivar permiso"}
					</DialogTitle>
					<DialogContent>
						{ 
							<DialogContentText id="alert-dialog-description">
								¿Seguro que deseas desactivar el permiso?
							</DialogContentText>
						}
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleCloseDeactivateDialog}
							color="secondary"
						>
							Cancelar
						</Button>
						{
							this.state.isActiveFaculty &&
							<Button 
								onClick={this.deactivateFaculty} 
								color="primary" autoFocus
							>
								Desactivar
							</Button>
						}
						{
							this.state.isActiveFaculty === false &&
							<Button 
								onClick={this.activateFaculty} 
								color="primary" autoFocus
							>
								Activar
							</Button>
						}
					</DialogActions>
				</Dialog>
			}
			{
				<LoadingOverlay
					active={this.state.activeLoader}
					isVisible={this.state.activeLoader}
					spinner
					text="Esto puede tardar unos minutos"
					styles={{
						wrapper: {
							width: this.state.activeLoader ? "100%" : "0%",
							height: this.state.activeLoader ? "100%" : "0%",
							overflow: "hidden",
						},
						overlay: (base) => ({
							...base,
							background: "rgba(10, 10, 10, 0.7)",
						}),
					}}
				></LoadingOverlay>
			}
			{
				<Snackbar
					open={this.state.showSnackBar}
					autoHideDuration={6000}
					onClose={this.handleClose}
				>
					<Alert
						onClose={this.handleClose}
						severity={this.state.severitySnackBar}
					>
						{this.state.textSnackBar}
					</Alert>
				</Snackbar>
			}
		</center>
	)
    }
}

const mapStateToProps = state => ({
	faculties: state.faculty_reducer.faculties,
	roles: state.rol_reducer.roles,
    actionType: state.faculty_reducer.actionType,
    error: state.faculty_reducer.error,
	success: state.success,
});

export default connect(
    mapStateToProps, {
        deactivateFaculty,
		activateFaculty,
		createFaculty,
		updateFaculty,
		getFaculties,
		getRoles
    }
)(FacultyComponent);